import React from 'react';
import classnames from 'classnames';

class ReactTabGroupButton extends React.Component {

  static defaultProps = {
    className: null,
    onClick: () => {},
    attributes: {},
    content: 'click here'
  };

  static propTypes = {
    className: React.PropTypes.string,
    attributes: React.PropTypes.object,
    onClick: React.PropTypes.func,
    content: React.PropTypes.string
  };

  displayName = 'ReactTabGroupButton';

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <a href="javascript:;" onClick={ this.props.onClick } {...this.props.attributes}
        className={ classnames('tabbar-btn col-33 tabbar-btn-danger', this.props.className) }
        dangerouslySetInnerHTML={{ __html: this.props.content }}>
      </a>
    );
  }
}

export default ReactTabGroupButton;



/** WEBPACK FOOTER **
 ** ./src/javascript/react-tab-group-button.jsx
 **/